import { commonRequest } from "../../../services/ApiCall";
import { Helpers } from "../../../services/Helpers";

export const CouponServices = {
    couponList : async (data)=>{
        console.log("filter Data",data);
        const queryParams = new URLSearchParams();

        // Basic pagination and sorting parameters
        queryParams.append('page', data.page + 1);
        queryParams.append('limit', data.limit);

        // Search parameters
        queryParams.append('searchKey', data.filters.searchKey || '');
        

        // Sorting parameters
        if (data.filters.sortBy) {
            queryParams.append('sortBy', data.filters.sortBy);            
            queryParams.append('sortType', data.filters.sortType || 'desc');
        }
        
        // // Active or not filters
        // queryParams.append('isActive', data.filters?.isActive || '');

        // Additional multi-column filters
        if (data.filters.filterOptions) {
            data.filters.filterOptions.forEach((filter, index) => {
                if (filter.fieldName && filter.value) {
                    queryParams.append(`filters[${index}][fieldName]`, filter.fieldName);
                    queryParams.append(`filters[${index}][operator]`, filter.operator);
                    queryParams.append(`filters[${index}][value]`, filter.value);
                    
                    if (index !== 0) {
                        queryParams.append(`filters[${index}][andOr]`, filter.andOr);
                    }
                    
                    if (filter.operator === 'between') {
                        queryParams.append(`filters[${index}][endValue]`, filter.endValue);                        
                    }
                }
            });
        }
        console.log("queryParams",queryParams.toString());
        return await commonRequest("GET",  `${Helpers.URL()}/api/v2/admin/coupon-manage/getCouponList?${queryParams.toString()}`,{}, Helpers.token());
    },
    exportCouponList : async (data)=>{
        console.log("filter Data",data);
        const queryParams = new URLSearchParams();

        // Search parameters
        queryParams.append('searchKey', data.filters.searchKey || '');
        

        // Sorting parameters
        if (data.filters.sortBy) {
            queryParams.append('sortBy', data.filters.sortBy);            
            queryParams.append('sortType', data.filters.sortType || 'desc');
        }
        
        // // Active or not filters
        // queryParams.append('isActive', data.filters?.isActive || '');

        // Additional multi-column filters
        if (data.filters.filterOptions) {
            data.filters.filterOptions.forEach((filter, index) => {
                if (filter.fieldName && filter.value) {
                    queryParams.append(`filters[${index}][fieldName]`, filter.fieldName);
                    queryParams.append(`filters[${index}][operator]`, filter.operator);
                    queryParams.append(`filters[${index}][value]`, filter.value);
                    
                    if (index !== 0) {
                        queryParams.append(`filters[${index}][andOr]`, filter.andOr);
                    }
                    
                    if (filter.operator === 'between') {
                        queryParams.append(`filters[${index}][endValue]`, filter.endValue);                        
                    }
                }
            });
        }
        console.log("queryParams",queryParams.toString());
        return await commonRequest("GET",  `${Helpers.URL()}/api/v2/admin/coupon-manage/getCouponList/export?${queryParams.toString()}`,{}, Helpers.token());
    },
    getCouponById : async (id)=>{
        return await commonRequest("GET", `${Helpers.URL()}/api/v2/admin/coupon-manage/couponDetails/${id}`,{}, Helpers.token());
    },
    addCoupon : async (data)=>{
        return await commonRequest("POST", `${Helpers.URL()}/api/v2/admin/coupon-manage/createCoupon`,data, Helpers.token());
    },
    updateCoupon : async (id,data)=>{
        return await commonRequest("PUT", `${Helpers.URL()}/api/v2/admin/coupon-manage/updateBanner/${id}`,data, Helpers.token());
    },
    changeStatus : async (id)=>{
        return await commonRequest("get", `${Helpers.URL()}/api/v2/admin/coupon-manage/modifyStatus/${id}`,{}, Helpers.token());
    },
    exportList : async (data) =>{
        console.log("data",data);
        const queryParams = new URLSearchParams();

        // Search parameters
        queryParams.append('searchKey', data.filters.searchKey || '');
        

        // Sorting parameters
        if (data.filters.sortKey) {
            queryParams.append('sortKey', data.filters.sortKey);            
            queryParams.append('sortDirection', data.filters.sortDirection || 'desc');
        }
        

        // Additional multi-column filters
        if (data.filters.filterOptions) {
            data.filters.filterOptions.forEach((filter, index) => {
                if (filter.fieldName && filter.value) {
                    queryParams.append(`filters[${index}][fieldName]`, filter.fieldName);
                    queryParams.append(`filters[${index}][operator]`, filter.operator);
                    queryParams.append(`filters[${index}][value]`, filter.value);
                    
                    if (index !== 0) {
                        queryParams.append(`filters[${index}][andOr]`, filter.andOr);
                    }
                    
                    if (filter.operator === 'between') {
                        queryParams.append(`filters[${index}][endValue]`, filter.endValue);                        
                    }
                }
            });
        }
        console.log("queryParams",queryParams.toString());
        return await commonRequest("get",  `${Helpers.URL()}/api/admin/reward/export-list?${queryParams.toString()}`, {}, Helpers.token());
    },
    getBannerCategoryList  : async (data)=>{ 
        return await commonRequest("GET", `${Helpers.URL()}/api/admin/banner-category/list`,{}, Helpers.token());
    },
    addBannerCategory : async (data)=>{
        return await commonRequest("POST", `${Helpers.URL()}/api/admin/banner-category/add`,data, Helpers.token());
    }
}